import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CurrentUserStateService } from '../services/current-user-state.service';
import { LoanCardDialogComponent } from './loan-card-dialog/loan-card-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ProfitabilityService } from '../../incentives/services/profitability.service';

@Component({
    selector: 'loan-details-tracker-modal',
    templateUrl: './loan-details-modal.component.html',
    styleUrls: ['./loan-details-modal.component.scss'],
})
export class LoanDetailsModalComponent implements OnInit {
    loanNumber: any;
    paramSnapShot: Params;

    constructor(
        private router: Router,
        private _activatedRoute: ActivatedRoute,
        private profitabilityService: ProfitabilityService,
        public currentUserStateService: CurrentUserStateService,
        private dialog: MatDialog
    ) {
        this._activatedRoute.params.subscribe((param) => {
            this.loanNumber = param.loanNumber;
        });
    }

    ngOnInit() {
        let dialogRef = this.dialog.open(LoanCardDialogComponent, {
            height: '90%',
            width: '1000px',
            data: {
                loanNumber: this.loanNumber,
            },
        });

        dialogRef.afterClosed().subscribe(() => {
            if (this.profitabilityService.dialogParametrs) {
                this.profitabilityService.dialogParametrs.isLoanProfitabilityDialog = false;
            }
            this.closeModal(null);
        });

        this.paramSnapShot = Object.assign({}, this._activatedRoute.snapshot.queryParams);
    }

    closeModal($event) {
        if (!this.router.url.includes('/incentives/insights/profitability')) {
            this.paramSnapShot['isLoanDetails'] = true;
        }

        this.router.navigate([{ outlets: { modal: null } }], {
            queryParams: this.paramSnapShot,
        });

        if (!this.currentUserStateService.isLoggedIn()) {
            this.router.navigate(['/login']);
        }
    }
}
